module.exports = __webpack_public_path__ + "img/expire_date.0f74858f.svg";